import dayjs from 'dayjs';

/**
 * 작성자 : 홍선영
 * 작성일자 : 2026-08-24
 * 작성내용 : 표시 구간(YYYYMMDD)을 감싸는 주 경계 구간을 반환한다.
 *            start = 표시 시작일이 속한 주의 일요일, end = 표시 종료일이 속한 주의 토요일.
 *
 * 배경 : /schedule/calendar 는 date1~date2 로 "달력 보드"를 만들어 그 칸에서만 반복 일정 발생일을 생성하고,
 *        보드의 첫 칸/끝 칸으로 일정 자체를 필터링한다. (BE schedule.service.ts getCalendarSize / createCalendarBoard)
 *        - 보드 시작은 date1 을 그 주 일요일로 스냅한 날이다.
 *        - 보드 크기는 date2 - date1 이 7일 미만이면 1주(7칸), 7일 이상이면 6주(42칸)다.
 *        표시 구간 7일(start+6)을 그대로 요청하면 보드가 그 주 토요일에서 끊겨,
 *        구간 꼬리 날짜(선택일의 요일 수만큼)에 일정이 아예 오지 않는다.
 *
 * 보장 : start 가 항상 일요일이라 서버 스냅이 범위를 더 당기지 않으므로
 *          diff < 7 → 보드 = start ~ start+6 = end
 *          diff >= 7 → 보드 = start ~ start+41 ⊇ end   (end - start <= 41 인 한)
 *        어느 쪽이든 보드 ⊇ [start, end] ⊇ 표시 구간이 성립한다.
 *        (7일 표시 구간에서 end - start 는 6일 또는 13일)
 *
 * 주의 : 전역 dayjs.locale()이 런타임에 바뀌므로 startOf('week')를 쓰지 않고 day()(0=일요일) 산술로 고정한다.
 */
export const getWeekAlignedQueryRange = (viewStart: string, viewEnd: string): { start: string; end: string } => {
  const startDay = dayjs(viewStart.replaceAll('-', ''));
  const endDay = dayjs(viewEnd.replaceAll('-', ''));

  return {
    start: startDay.subtract(startDay.day(), 'day').format('YYYYMMDD'), // 그 주의 일요일
    end: endDay.add(6 - endDay.day(), 'day').format('YYYYMMDD'), // 그 주의 토요일
  };
};
